import Head from 'next/head'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useWindow } from '../hooks/use.window'

interface OwnProps {
  title?: string
}
type Props = OwnProps

const OpenGraph: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const window = useWindow()

  const imageUrl = 'https://static.rect.ag/assets/img/tucan@426.png'
  const url = `https://${window ? window.location.host : 'tucan.ai.'}/`

  const siteName = t('og-site-name', 'We make your Meetings work!')
  const title = t('og-title', 'tucan.ai - SaaS')
  const description = t(
    'og-description',
    'Automatic transcripts, ' +
    'summaries and rich notes-focus on your conversation, ' +
    'let tucan.ai take care of the rest!',
  )
  return (
    <Head>
      <meta property={'og:type'} content={'article'} key="og:type" />
      <meta property={'og:title'} content={title || props.title} key="og:title" />
      <meta property={'og:description'} content={description} key="og:description" />
      <meta property={'og:site_name'} content={siteName} key="og:site_name" />
      <meta property={'og:image'} content={imageUrl} key="og:image" />
      <meta property={'og:url'} content={url} key="og:url" />
      <meta name={'twitter:card'} content={imageUrl} />
      <title key="title">{props.title || title}</title>
      <meta name={'description'} content={description} />
    </Head>
  )
}

export default OpenGraph
